export default {
  saledFeedback: '售后反馈',
  orderNo: '订单编号',
  unreply: '未回复',
  replied: '已回复',
  apply: '申请',
  badImg: '不良图片',
  applyDetail: '申请详情',
  replyDate: '回复日期',
  replyContent: '回复内容',
  orderMsg: '订单消息',
  otherMsg: '其他消息',
  clickUpload: '点击上传',
  uploadRefreshTip: '请等待所有图片上传成功或出现了网络问题，请刷新页面重新上传',
  uploadNumberTip: '最多可上传4张图片',
  uploadNumberTip9: '最多可上传9张图片',
};
